module.exports = __webpack_public_path__ + "img/edit_d.c9cb842b.svg";